/** * 程序升级公告详情组件 * 创建时间：2017-07-03 * 创建人：Shujuan Sun */
<template>
	<div class="tabBox">
		<div class="text-center float-e-margins p-md">
			<h3>系统升级详情</h3>
		</div>
		<div class="" id="ibox-content">
			<div id="vertical-timeline" class="vertical-container light-timeline" v-for="(versionInfo,index) in versionList">
				<div class="vertical-timeline-block">
					<div class="vertical-timeline-icon blue-bg">
						<i class="fa fa-file-text"></i>
					</div>
					<div class="vertical-timeline-content">
						<h2>{{versionInfo.versionName}}</h2>
						<div v-html="versionInfo.content"></div>
						<span class="vertical-date">
                            <small>{{versionInfo.versionDate}}</small>
                        </span>
					</div>
				</div>
			</div>
		</div>
		<!--页面tab弹框组件开始-->				
		<main-modal ref="modal1" size="small" title="提示" >
			<p v-text="tipContent"></p>	
			<div slot="footer">
				<button class="btn btn-primary" @click="closetip">关闭</button>
			</div>
		</main-modal>
	</div>
</template>

<script>
 	import MainModal from 'components/common/MainModal'
	export default {
		name: 'Update',
		data(){
			return {
				versionList:[],
				tipContent:''
			}
		},
		components:{
			MainModal
		},
		beforeMount() {
			const param = {
				last:1,
				source:2
			}
			//process.env.API_ROOT + '/noauth/timeline',param
			//'../../../../static/update/updateList.json'
			this.$http.get(process.env.API_ROOT + '/noauth/timeline',{params:param})
			.then(res=>{
				this.versionList = res.body.data
			},res=>{
				this.$refs.modal1.open()
				this.tipContent = res.body.message
			})
			.catch(res=>{
				this.$refs.modal1.open()
				this.tipContent = '请求异常'
			})
		},
		methods: {
			closetip(){
				this.$refs.modal1.close()
			}
		}

	}
</script>


// WEBPACK FOOTER //
// Update.vue?7690b5e4